import { apolloProvider } from '@/modules/GraphQL';
import { GET_MATERIAL } from '@/graphql/Mystage/material';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';

export const GetMaterialService = {
  // Method to fetch Material from new GraphQL endpoint
  new: async (booking_id, test, isTrial, callback, jwtKeyValue, preload = 0) => {
      logger.info(`[Materials] Fetching Materials from new GraphQL endpoint`, {
        operation: 'materials:get_materials'
      });

      const client = apolloProvider.defaultClient;
      const { data } = await client.query({
        query: GET_MATERIAL,
        fetchPolicy: 'no-cache',
        variables: {
          b: parseInt(booking_id),
          test: parseInt(test),
          preload: preload,
        }
      });
      
      if (data?.mystage_get_materials) {
        callback(data.mystage_get_materials);
      } else {
        this.$logger.error(
            `[Materials][Rank ID ${this.studentRank}][Lesson No ${this.studentLessonNo}] Empty result from materials api`,
            { operation: 'materials:get',event_type:4,lesson_id:this.lessonId }
          );
      }
  },

  // Method to fetch Material from legacy REST API endpoint
  legacy: async (booking_id, test, isTrial, callback, jwtKeyValue, preload = 0) => {
    logger.info(`[Materials] Fetching Materials from legacy endpoint`, {
      operation: 'materials:get_materials'
    });
    let path,
        params = {};
      if (isTrial) {
        path = 'sales/materials';
        params = {
          params: {...jwtKeyValue}
        };
      } else {
        path = `materials/materials.json?b=${booking_id}&test=${test}&preload=${preload}`;
      }

      await bizmatesApi.get(path, params, response => {
        if (response.data && response.data.length) {
          callback(response.data);
        } else {
          this.$logger.error(
            `[Materials][Rank ID ${this.studentRank}][Lesson No ${this.studentLessonNo}] Empty result from materials api`,
            { operation: 'materials:get',event_type:4,lesson_id:this.lessonId }
          );
        }
      });
  }
};